<div class="alert alert-success has-icon alert-large" role="alert">
  <span><i class="fal fa-check-circle me-3 mt-1"></i></span>
  <div class="alert-content">
    <p class="mb-0">{{message}}</p>
  </div>
</div>
